let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jCDAd")).then(() => parcelRequire('75X4q'));